import * as S from './styled'

const Ellipsis = ({ children, clamp, ...props }) => (
  <S.Container clamp={clamp} {...props}>
    {children}
  </S.Container>
)

export default Ellipsis
